<template>
  <div>
    <div
      v-for="(item, index) in data"
      :class="{
        'account-info': true,
        '-spacing-c': true,
        'account-info--open': toggle.indexOf(item.id) >= 0 || item.isAlwaysOpen,
        [`account-info--${item.id}`]: true
      }"
      :key="index"
    >
      <div
        v-if="item.title"
        class="account-info__bar"
        @click="toggleDetails(item.id)"
      >
        <div
          :class="{
            icon: true,
            'icon--arrow-down-hair': true,
            'account-info__icon': true,
            'account-info__icon--open':
              toggle.indexOf(item.id) >= 0 || item.isAlwaysOpen
          }"
        ></div>
        <div class="account-info__header">
          <h2 class="account-info__title">{{ item.title }}</h2>
        </div>
      </div>
      <div
        :class="{
          'account-info__dropdown': true,
          'account-info__dropdown--open':
            toggle.indexOf(item.id) >= 0 || item.isAlwaysOpen
        }"
      >
        <div
          v-if="item.content"
          class="account-info__content"
          v-html="item.content"
        ></div>
        <div v-else class="columns">
          <div
            class="account-info__image-wrapper column is-half"
            v-if="typeof item.image !== 'undefined'"
          >
            <img :src="require(`@/assets/img/temp/${item.image}`)" alt />
          </div>

          <dl
            v-if="typeof item.detailsLeft !== 'undefined'"
            class="column is-half"
          >
            <template v-for="(detail, index) in item.detailsLeft">
              <dt v-bind:key="'term-' + index">{{ detail.term }}</dt>
              <dd
                v-bind:key="'description-' + index"
                v-html="detail.description"
              ></dd>
            </template>
          </dl>

          <dl
            v-if="typeof item.detailsRight !== 'undefined'"
            class="column is-half"
          >
            <template v-for="(detail, index) in item.detailsRight">
              <dt v-bind:key="'term-' + index">{{ detail.term }}</dt>
              <dd
                v-bind:key="'description-' + index"
                v-html="detail.description"
              ></dd>
            </template>
          </dl>
        </div>

        <div class="account-info__buttons" v-if="item.hasButtons">
          <template v-if="item.id === 'policy'">
            <router-link
              class="account-info__button button-primary button-primary--muted-gray"
              to="/account/statements"
            >
              <span
                class="button-primary__icon icon icon--arrow-right-hair"
              ></span>
              <span class="button-primary__label">View My Statement</span>
            </router-link>

            <router-link
              class="account-info__button button-primary button-primary--muted-gray"
              to="/account/request-card"
            >
              <span
                class="button-primary__icon icon icon--arrow-right-hair"
              ></span>
              <span class="button-primary__label">Request ID Card</span>
            </router-link>
          </template>

          <template v-if="item.id === 'vehicle'">
            <router-link
              class="account-info__button button-primary button-primary--muted-gray"
              to="/account/address"
            >
              <span
                class="button-primary__icon icon icon--arrow-right-hair"
              ></span>
              <span class="button-primary__label">Change Address</span>
            </router-link>

            <router-link
              class="account-info__button button-primary button-primary--muted-gray"
              to="/account/vehicles"
            >
              <span
                class="button-primary__icon icon icon--arrow-right-hair"
              ></span>
              <span class="button-primary__label">Add/Replace Vehicle</span>
            </router-link>
          </template>

          <template v-if="item.id === 'coverage'">
            <router-link
              class="account-info__button button-primary button-primary--muted-gray"
              to="/account/coverage"
            >
              <span
                class="button-primary__icon icon icon--arrow-right-hair"
              ></span>
              <span class="button-primary__label">Change Coverage</span>
            </router-link>
          </template>

          <template v-if="item.id === 'drivers'">
            <router-link
              class="account-info__button button-primary button-primary--muted-gray"
              to="/account/drivers"
            >
              <span
                class="button-primary__icon icon icon--arrow-right-hair"
              ></span>
              <span class="button-primary__label">Add/Edit Drivers</span>
            </router-link>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AccountInfo',
  props: ['data'],
  data() {
    return {
      toggle: []
    };
  },
  methods: {
    toggleDetails: function(key) {
      let i = this.toggle.indexOf(key);

      if (i < 0) {
        this.toggle.push(key);
      } else {
        this.toggle.splice(i, 1);
      }
    }
  }
};
</script>
